import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface CountdownValue {
  d: number;
  h: number;
  m: number;
  s: number;
}

function computeValue(targetMs: number): CountdownValue {
  const diff = Math.max(0, targetMs - Date.now()) / 1000;
  return {
    d: Math.floor(diff / 86400),
    h: Math.floor((diff % 86400) / 3600),
    m: Math.floor((diff % 3600) / 60),
    s: Math.floor(diff % 60),
  };
}

/** Обратный отсчёт (`#cd1`/`#cd3` макета) — требование «Таймеры лендинга». */
export function useCountdown(targetIso: string): CountdownValue {
  const targetMs = new Date(targetIso).getTime();
  const [value, setValue] = useState(() => computeValue(targetMs));

  useEffect(() => {
    const id = setInterval(() => setValue(computeValue(targetMs)), 1000);
    return () => clearInterval(id);
  }, [targetMs]);

  return value;
}

interface CountdownProps {
  targetIso: string;
  className?: string;
}

export function Countdown({ targetIso, className }: CountdownProps) {
  const { t, i18n } = useTranslation('landing');
  const v = useCountdown(targetIso);
  // Intl.*, не ручной padStart — правило «Многоязычность (i18n)» в docs/project.md.
  const fmt = new Intl.NumberFormat(i18n.language, { minimumIntegerDigits: 2 });
  return (
    <div className={className ? `countdown ${className}` : 'countdown'}>
      <div className="cd">
        <b>{fmt.format(v.d)}</b>
        <small>{t('countdown.days')}</small>
      </div>
      <div className="cd">
        <b>{fmt.format(v.h)}</b>
        <small>{t('countdown.hours')}</small>
      </div>
      <div className="cd">
        <b>{fmt.format(v.m)}</b>
        <small>{t('countdown.minutes')}</small>
      </div>
      <div className="cd">
        <b>{fmt.format(v.s)}</b>
        <small>{t('countdown.seconds')}</small>
      </div>
    </div>
  );
}
